import { render, staticRenderFns } from "./CounselorButtons.vue?vue&type=template&id=063c5669&scoped=true&"
import script from "./CounselorButtons.vue?vue&type=script&lang=js&"
export * from "./CounselorButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c5669",
  null
  
)

export default component.exports